<script lang="ts">
	import { isNotEmpty } from './utils/shared'
	import { sceneTypes } from './types'
	import useAuthStore from '@/stores/auth/auth'

	import { TUIChatKit } from './TUIKit'

	TUIChatKit.init()


	export default {
		globalData: {
			uuid: '',
			source: '',
			recommandUserCode: '',
		},
		onLaunch: function (options : any) {
			console.log('App Launch')
			console.log('应用启动路径：', options)
			if (options && isNotEmpty(options.scene) && sceneTypes.includes(options.scene)) {
				this.globalData.source = options.source
			}
			this.globalData.recommandUserCode = options && isNotEmpty(options.recommandUserCode) ? options.recommandUserCode : ''
			const authStore = useAuthStore()
			authStore.initFromStorage()
		},
		onShow: function (options : any) {
			console.log('App Show')
			console.log('应用启动路径：', options)
		},

		onHide: function () {
			console.log('App Hide')
		},
	}
</script>

<style lang="scss">
	@import '@/styles/common.scss';

	/*每个页面公共css */
	uni-page-body,
	html,
	body,
	page {
		width: 100% !important;
		height: 100% !important;
		overflow: hidden;
	}
</style>